import React, { Component } from 'react'

import Header from '../components/header'
import Footer from '../components/footer'
import '../assets/scss/main.scss'
import Client from "shopify-buy"

class Layout extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isCartOpen: false,
      cartRequest: false,
      checkout: { lineItems: [] },
      products: [],
      shop: {},
    }
  }

  componentDidMount() {
    this.client = Client.buildClient({
      domain: "emily-gillis.myshopify.com",
      storefrontAccessToken: "9491f6b8b462a71fd74f6b887dc5b6e5",
    })
    this.client.checkout.create().then((checkout) => {
      this.setState({ checkout })
    })
  }

  _fetchProducts(query) {
    this.client.product.fetchAll().then((products) => {
      this.setState({ ...this.state, products })
    })
  }

  _addVariantToCart(variantId, quantity) {
    this.setState({ isCartOpen: true, cartRequest: true })

    console.log(variantId)

    const lineItemsToAdd = [{ variantId, quantity: parseInt(quantity, 10) }]
    const checkoutId = this.state.checkout.id

    return this.client.checkout
      .addLineItems(checkoutId, lineItemsToAdd)
      .then((checkout) => this.setState({ checkout, cartRequest: false }))
  }

  _updateQuantityInCart(lineItemId, quantity) {
    const checkoutId = this.state.checkout.id
    const lineItemsToUpdate = [
      { id: lineItemId, quantity: parseInt(quantity, 10) },
    ]
    this.setState({ isCartOpen: true, cartRequest: true })

    return this.client.checkout
      .updateLineItems(checkoutId, lineItemsToUpdate)
      .then((checkout) => this.setState({ checkout, cartRequest: false }))
  }

  _removeLineItemInCart(lineItemId) {
    const checkoutId = this.state.checkout.id
    this.setState({ isCartOpen: true, cartRequest: true })

    return this.client.checkout
      .removeLineItems(checkoutId, [lineItemId])
      .then((checkout) => this.setState({ checkout, cartRequest: false }))
  }

  render() {
    let { children, location } = this.props
    const { checkout, isCartOpen, cartRequest, products } = this.state

    children = React.Children.map(children, (child) =>
      React.cloneElement(child, {
        addVariantToCart: this._addVariantToCart.bind(this),
        updateQuantityInCart: this._updateQuantityInCart.bind(this),
        removeLineItemInCart: this._removeLineItemInCart.bind(this),
        fetchProducts: this._fetchProducts.bind(this),
        checkout: checkout,
        products: products,
      })
    )
    return (
      <>
        <Header 
          pathname={location.pathname}
          isCartOpen={isCartOpen}
          setIsCartOpen={(val) => this.setState({ isCartOpen : val })}
          cartRequest={cartRequest}
          cartCount={checkout.lineItems.length}
          checkout={checkout}
          updateQuantityInCart={this._updateQuantityInCart.bind(this)}
          removeLineItemInCart={this._removeLineItemInCart.bind(this)}
        />
        <main>
          { children }
        </main>
        <Footer />
      </>
    )
  }
}
export default Layout